import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { ContractSignatureType } from 'src/app/domain/enums/contract-signature-type.enum';
import { IContractSignature } from 'src/app/domain/registration/models/IContractSignature';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { extractDocumentFromEntity, formatDocument } from 'src/app/shared/utils/document-formatter';
import { AddSignatureDialogComponent } from '../contract-dialog/add-signature-dialog/add-signature-dialog.component';
import { ContractGenerationService } from '../../services/contract-generation.service';
import { CustomerIndexSelectComponent } from '../../../customers/crud-index/crud-index-select.component';
import { PartnerIndexSelectComponent } from '../../../partners/crud-index/crud-index-select.component';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { CustomerService } from '../../../customers/crud-service';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { IPartnerContractRole } from 'src/app/domain/registration/interfaces/contract-type.interface';
import { ContractTypeResolverService } from '../../../partners/services/contract-type-resolver.service';
import { HttpClient } from '@angular/common/http';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { CONFIG_VARIABLES_CONTRACT } from '../../crud-config';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { PlanSelectionWizardComponent } from '../../../plans/plan-selection-wizard/plan-selection-wizard.component';
import { plansIdStandaloneContract } from '../../helpers/contracts-dialog.helper';
import { ContractPreviewDialogComponent } from '../contract-dialog/contract-preview-dialog/contract-preview-dialog.component';
import { PartnerService } from '../../../partners/crud-service';
import { lastValueFrom } from 'rxjs';

/**
 * Componente para geração de contratos avulsos
 * Permite criar contratos opcionalmente vinculados a clientes ou parceiros
 */
@Component({
    selector: 'app-standalone-contract-dialog',
    templateUrl: './standalone-contract-dialog.component.html',
    styleUrls: ['./standalone-contract-dialog.component.sass']
})
export class StandaloneContractDialogComponent implements OnInit {
    contractForm: FormGroup;
    typeCes: TypeCesEnum;
    variablesForm: FormGroup;
    planId: plansIdStandaloneContract;
    config: IFieldConfig[] = CONFIG_VARIABLES_CONTRACT;
    private storedVariablesControl: AbstractControl | null = null;
    signatures = new MatTableDataSource<IContractSignature>([]);
    displayedColumns: string[] = ['name', 'email', 'document', 'type', 'actions'];
    signatureTypes = ContractSignatureType;
    loading = false;
    isLoading = false;
    selectedEntity: any = null;
    entityType: 'customer' | 'partner' | null = null;
    customerPlans: any[] = [];
    allTemplates: any[] = [];
    plansStandalone: any[] = [];
    selectedPlan: any = null;
    partnerRoles: IPartnerContractRole[] = [];
    selectedPartnerRole: IPartnerContractRole | null = null;
    templateFile: File | null = null;
    templateFileName: string = '';
    loadTemplates: any;
    @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;

    // --- MOCK DE DADOS 1: ASSINANTE CPF ---
    mockDataCPF = {
        subscriberName: "Ana Clara Silva",
        subscriberDocument: "123.456.789-00",
        subscriberDocumentType: "CPF",
        subscriberEmail: "ana.clara.silva@exemplo.com",
        subscriberTelephone: "(11) 98765-4321",
        subscriberPhone: "(11) 91122-3344",
        subscriberAddressNumber: "Rua das Flores, 150",
        subscriberCity: "São Paulo",
        subscriberState: "SP",
        subscriberCep: "01234-567",

        contractorName: "Tech Solutions LTDA",
        contractorDocument: "01.234.567/0001-88",
        contractorEmail: "financeiro@techsolutions.com",
        contractorTelephone: "(21) 5555-4444",
        contractorAddress: "Avenida Principal, 1000, Sala 50, Centro",
        contractorCity: "Rio de Janeiro",
        contractorState: "RJ",
        contractorNameContract: "Tech Solutions Serviços de Tecnologia LTDA ME",
        contractorDocumentContract: "01.234.567/0001-88",

        dueDate: "10",
        firstDueDate: "10/12/2025"
    };

    // --- MOCK DE DADOS 2: ASSINANTE CNPJ ---
    mockDataCNPJ = {
        subscriberName: "Padaria Pão Quente",
        subscriberDocument: "99.888.777/0001-55",
        subscriberDocumentType: "CNPJ",
        subscriberEmail: "compras@paoquente.com.br",
        subscriberTelephone: "(81) 3456-7890",
        subscriberPhone: "(81) 99999-8888",
        subscriberAddressNumber: "Avenida Boa Viagem, 5010",
        subscriberCity: "Recife",
        subscriberState: "PE",
        subscriberCep: "51000-000",

        contractorName: "Sistemas de Gestão SA",
        contractorDocument: "02.468.135/0001-99",
        contractorEmail: "contato@gestaosa.com",
        contractorTelephone: "(41) 3333-2222",
        contractorAddress: "Rua XV de Novembro, 1234, Andar 10, Batel",
        contractorCity: "Curitiba",
        contractorState: "PR",
        contractorNameContract: "Sistemas de Gestão S.A.",
        contractorDocumentContract: "02.468.135/0001-99",

        dueDate: "25",
        firstDueDate: "25/12/2025"
    };

    // Variáveis disponíveis para o template
    availableVariables: { category: string, variables: { name: string, description: string }[] }[] = [];

    constructor(
        private fb: FormBuilder,
        private http: HttpClient,
        public dialogRef: MatDialogRef<StandaloneContractDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { contractGenerationService: ContractGenerationService },
        private dialog: MatDialog,
        private datePipe: DatePipe,
        private authService: AuthService,
        private toastService: ToastService,
        private contractGenerationService: ContractGenerationService,
        private customerService: CustomerService,
        private contractTypeResolver: ContractTypeResolverService,
        private partnerService: PartnerService
    ) {

        this.contractForm = this.fb.group({
            title: ['', Validators.required],
            type: ['manual', Validators.required],
            templateFile: [null]
        });

        this.variablesForm = this.fb.group({
            subscriberName: ['', Validators.required],
            subscriberDocument: ['', Validators.required],
            subscriberDocumentType: ['', Validators.required],
            subscriberEmail: ['', Validators.required],
            subscriberTelephone: ['', Validators.required],
            subscriberPhone: ['', Validators.required],
            subscriberAddressNumber: ['', Validators.required],
            subscriberCity: ['', Validators.required],
            subscriberState: ['', Validators.required],
            subscriberCep: ['', Validators.required],

            contractorName: ['', Validators.required],
            contractorDocument: ['', Validators.required],
            contractorEmail: ['', Validators.required],
            contractorTelephone: ['', Validators.required],
            contractorAddress: ['', Validators.required],
            contractorCity: ['', Validators.required],
            contractorState: ['', Validators.required],
            contractorNameContract: ['', Validators.required],
            contractorDocumentContract: ['', Validators.required],

            dueDate: ['', Validators.required],
            firstDueDate: ['', Validators.required],

            templatesActives: [[]]

        });

        this.addCurrentUserSignature();
    }

    ngOnInit(): void {
        this.initializeAvailableVariables();
        this.loadAllTemplates();

        // guarda controle 'variables' se existir e aplica comportamento conforme campo 'type'
        if (this.contractForm.contains('variables')) {
            this.storedVariablesControl = this.contractForm.get('variables') as AbstractControl;
        }

        const typeControl = this.contractForm.get('type');
        if (typeControl) {
            // estado inicial
            if (typeControl.value === 'manual' && this.contractForm.contains('variables')) {
                this.storedVariablesControl = this.contractForm.get('variables') as AbstractControl;
                this.contractForm.removeControl('variables');
                if (this.selectedEntity) {
                    this.clearEntity();
                }
            }

            // observa mudanças e remove / re-adiciona 'variables'
            typeControl.valueChanges.subscribe((type: string) => {
                const isManual = type === 'manual';
                if (isManual && this.contractForm.contains('variables')) {
                    this.storedVariablesControl = this.contractForm.get('variables') as AbstractControl;
                    this.contractForm.removeControl('variables');
                    if (this.selectedEntity) {
                        this.clearEntity();
                    }
                } else if (!isManual && !this.contractForm.contains('variables')) {
                    if (this.storedVariablesControl) {
                        this.contractForm.addControl('variables', this.storedVariablesControl);
                    } else {
                        this.contractForm.addControl('variables', this.fb.group({}));
                    }
                }
                this.getFieldConfig('templatesActives').options = isManual ?
                    this.allTemplates.filter((r: any) => r.type === 'standalone') :
                    this.allTemplates.filter((r: any) => r.type === 'standalone-automatic');
            });
        }
    }

    /**
     * Inicializa a lista de variáveis disponíveis baseadas no backend
     */
    private initializeAvailableVariables(): void {
        this.availableVariables = [
            {
                category: 'Cliente',
                variables: [
                    { name: '{nome_cliente}', description: 'Nome do cliente' },
                    { name: '{documento_cliente}', description: 'CPF ou CNPJ do cliente' },
                    { name: '{tipo_documento_cliente}', description: 'Tipo: CPF ou CNPJ' },
                    { name: '{inscrito_inscrita}', description: 'Texto: inscrito no CPF ou inscrita no CNPJ' },
                    { name: '{email_cliente}', description: 'Email do cliente' },
                    { name: '{telefone_cliente}', description: 'Telefone do cliente' },
                    { name: '{celular_cliente}', description: 'Celular do cliente' },
                    { name: '{endereco_cliente}', description: 'Endereço do cliente' },
                    { name: '{endereco_completo_cliente}', description: 'Endereço completo do cliente' },
                    { name: '{cidade_cliente}', description: 'Cidade do cliente' },
                    { name: '{estado_cliente}', description: 'Estado do cliente' },
                    { name: '{cep_cliente}', description: 'CEP do cliente' },
                ]
            },
            {
                category: 'Parceiro',
                variables: [
                    { name: '{nome_parceiro}', description: 'Nome do parceiro' },
                    { name: '{documento_parceiro}', description: 'CPF ou CNPJ do parceiro' },
                    { name: '{email_parceiro}', description: 'Email do parceiro' },
                    { name: '{telefone_parceiro}', description: 'Telefone do parceiro' },
                    { name: '{endereco_completo_parceiro}', description: 'Endereço completo do parceiro' },
                    { name: '{cidade_parceiro}', description: 'Cidade do parceiro' },
                    { name: '{estado_parceiro}', description: 'Estado do parceiro' },
                    { name: '{nome_contrato_parceiro}', description: 'Nome do parceiro no contrato' },
                    { name: '{documento_contrato_parceiro}', description: 'Documento do parceiro no contrato' },
                ]
            },
            {
                category: 'Contratado',
                variables: [
                    { name: '{nome_contratado}', description: 'Nome do contratado' },
                    { name: '{documento_contratado}', description: 'CPF ou CNPJ do contratado' },
                    { name: '{tipo_documento_contratado}', description: 'Tipo: CPF ou CNPJ' },
                    { name: '{inscrito_inscrita_contratado}', description: 'Texto: inscrito no CPF ou inscrita no CNPJ' },
                    { name: '{email_contratado}', description: 'Email do contratado' },
                    { name: '{telefone_contratado}', description: 'Telefone do contratado' },
                    { name: '{celular_contratado}', description: 'Celular do contratado' },
                    { name: '{endereco_contratado}', description: 'Endereço do contratado' },
                    { name: '{endereco_completo_contratado}', description: 'Endereço completo do contratado' },
                    { name: '{cidade_contratado}', description: 'Cidade do contratado' },
                    { name: '{estado_contratado}', description: 'Estado do contratado' },
                    { name: '{cep_contratado}', description: 'CEP do contratado' }
                ]
            },
            {
                category: 'Contratante',
                variables: [
                    { name: '{nome_contratante}', description: 'Nome do contratante' },
                    { name: '{documento_contratante}', description: 'CPF ou CNPJ do contratante' },
                    { name: '{tipo_documento_contratante}', description: 'Tipo: CPF ou CNPJ' },
                    { name: '{inscrito_inscrita_contratante}', description: 'Texto: inscrito no CPF ou inscrita no CNPJ' },
                    { name: '{email_contratante}', description: 'Email do contratante' },
                    { name: '{telefone_contratante}', description: 'Telefone do contratante' },
                    { name: '{endereco_completo_contratante}', description: 'Endereço completo do contratante' },
                    { name: '{cidade_contratante}', description: 'Cidade do contratante' },
                    { name: '{estado_contratante}', description: 'Estado do contratante' },
                    { name: '{nome_contratante_contrato}', description: 'Nome do contratante no contrato' },
                    { name: '{documento_contratante_contrato}', description: 'Documento do contratante no contrato' },
                ]
            },
            {
                category: 'Sistema/Plano vinculado a Cliente ou Parceiro',
                variables: [
                    { name: '{nome_sistema}', description: 'Nome do sistema' },
                    { name: '{nome_plano}', description: 'Nome do plano' },
                    { name: '{valor_mensalidade}', description: 'Valor da mensalidade' },
                    { name: '{valor_plano}', description: 'Valor do plano' },
                    { name: '{qtd_terminais_plano}', description: 'Quantidade de terminais' },
                    { name: '{taxa_adesao_plano}', description: 'Taxa de adesão' },
                    { name: '{valor_implantacao_plano}', description: 'Valor de implantação' },
                    { name: '{nome_modulo_plano}', description: 'Nome dos módulos' },
                ]
            },
            {
                category: 'Sistema/Plano sem vinculo',
                variables: [
                    { name: '{nome_plano}', description: 'Nome do plano' },
                    { name: '{valor_plano}', description: 'Valor do plano' },
                    { name: '{qtd_terminais_plano}', description: 'Quantidade de terminais' },
                    { name: '{taxa_adesao_plano}', description: 'Taxa de adesão' },
                ]
            },
            {
                category: 'Datas',
                variables: [
                    { name: '{data_atual}', description: 'Data atual' },
                    { name: '{mes_atual}', description: 'Mês atual por extenso' },
                    { name: '{dia_atual}', description: 'Dia atual' },
                    { name: '{ano_atual}', description: 'Ano atual' },
                    { name: '{data_vencimento}', description: 'Data de vencimento' },
                    { name: '{data_primeiro_vencimento}', description: 'Data do primeiro vencimento' },
                ]
            },
        ];
    }

    /**
     * Abre modal para selecionar cliente
     */
    selectCustomer(): void {
        const dialogRef = this.dialog.open(CustomerIndexSelectComponent, {
            width: '80%',
            height: '80%',
            data: {
                type: TypeIndexEnum.SELECT,
                select: true,
                params: {}
            },
            disableClose: false
        });

        dialogRef.afterClosed().subscribe((customer) => {
            if (customer) {
                this.selectedEntity = customer;
                this.entityType = 'customer';
                this.loadCustomerPlans(customer.id);
                this.updateSignaturesWithEntity();
            }
        });
    }

    /**
     * Abre modal para selecionar parceiro
     */
    selectPartner(): void {
        const dialogRef = this.dialog.open(PartnerIndexSelectComponent, {
            width: '80%',
            height: '80%',
            data: {
                type: TypeIndexEnum.SELECT,
                select: true,
                params: {}
            },
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(async (partner) => {
            if (partner) {
                this.selectedEntity = partner;
                this.entityType = 'partner';
                await this.loadPartnerRoles(partner);
                this.updateSignaturesWithEntity();
            }
        });
    }

    /**
     * Carrega os planos do cliente
     */
    private loadCustomerPlans(customerId: string): void {
        this.isLoading = true;
        this.customerService.get(customerId).subscribe({
            next: (customer: any) => {
                if (customer && customer.customerPlans) {
                    this.customerPlans = customer.customerPlans;
                } else {
                    this.customerPlans = [];
                    this.toastService.showInfo('Cliente não possui planos cadastrados');
                }
                this.isLoading = false;
            },
            error: (error) => {
                this.toastService.showError('Erro ao carregar planos do cliente');
                console.error('Erro ao carregar planos:', error);
                this.customerPlans = [];
                this.isLoading = false;
            }
        });
    }

    /**
     * Carrega os papéis/tipos disponíveis do parceiro
     */
    private async loadPartnerRoles(partner: any): Promise<void> {
        this.isLoading = true;
        try {
            this.partnerRoles = await this.contractTypeResolver.getPartnerContractRolesWithStatus(partner);
        } catch (error) {
            this.toastService.showError('Erro ao carregar tipos de contrato do parceiro');
            console.error('Erro ao carregar roles:', error);
            this.partnerRoles = [];
        } finally {
            this.isLoading = false;
        }
    }

    /**
     * Quando um plano é selecionado
     */
    onPlanSelect(plan: any): void {
        this.selectedPlan = plan;
    }

    /**
     * Quando um tipo de parceiro é selecionado
     */
    onPartnerRoleSelect(role: IPartnerContractRole): void {
        if (role.hasActiveContract) {
            this.toastService.showWarn(`Este parceiro já possui um contrato de ${role.label} assinado`);
            return;
        }
        this.selectedPartnerRole = role;
    }

    /**
     * Remove a entidade selecionada
     */
    clearEntity(): void {
        this.selectedEntity = null;
        this.entityType = null;
        this.customerPlans = [];
        this.selectedPlan = null;
        this.partnerRoles = [];
        this.selectedPartnerRole = null;
    }

    /**
     * Atualiza as assinaturas quando uma entidade é selecionada
     */
    private updateSignaturesWithEntity(): void {
        if (!this.selectedEntity) return;

        const documento = extractDocumentFromEntity(this.selectedEntity);
        const documentoFormatado = formatDocument(documento);
        const nome = this.entityType === 'customer'
            ? GlobalUtils.getCustomerDisplayName(this.selectedEntity)
            : (this.selectedEntity.name || this.selectedEntity.companyName || this.selectedEntity.tradingName);

        // Verificar se já existe
        const existingIndex = this.signatures.data.findIndex(
            s => s.email?.toLowerCase() === this.selectedEntity.email?.toLowerCase()
        );

        const entitySignature: IContractSignature = {
            code: this.generateSignatureCode(),
            name: nome,
            email: this.selectedEntity.email,
            document: documentoFormatado,
            whatsAppNumber: this.selectedEntity.cellPhone || this.selectedEntity.phone || '',
            type: this.entityType === 'customer' ? ContractSignatureType.CONTRATANTE : ContractSignatureType.PARCEIRO_REPRESENTANTE,
            status: 'PENDENTE',
            isContracted: true,
            isDefaultContracted: false
        };

        if (existingIndex !== -1) {
            const updatedSignatures = [...this.signatures.data];
            updatedSignatures[existingIndex] = entitySignature;
            this.signatures.data = updatedSignatures;
        } else {
            this.signatures.data = [...this.signatures.data, entitySignature];
        }
    }

    /**
     * Quando um arquivo de template é selecionado
     */
    onTemplateFileSelect(event: any): void {
        const file = event.target.files[0];
        if (file) {
            // Validar tipo de arquivo
            const validTypes = [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                'application/msword', // .doc
                'application/pdf'
            ];

            if (!validTypes.includes(file.type)) {
                this.toastService.showError('Por favor, selecione um arquivo DOCX ou PDF');
                return;
            }

            this.templateFile = file;
            this.templateFileName = file.name;
            console.log("files:", file)
            this.contractForm.patchValue({ templateFile: file });

            this.variablesForm.get('templatesActives')?.setValue(null);
        }
    }

    /**
     * Remove o arquivo de template selecionado
     */
    clearTemplateFile(): void {
        this.templateFile = null;
        this.templateFileName = '';
        this.contractForm.patchValue({ templateFile: null });
        // Reset the native file input so selecting the same file again will trigger change
        try {
            if (this.fileInputRef && this.fileInputRef.nativeElement) {
                this.fileInputRef.nativeElement.value = '';
            }
        } catch (e) {
            console.warn('Could not reset file input value', e);
        }
    }

    /**
     * Adiciona o usuário atual como signatário se for parceiro
     */
    private async addCurrentUserSignature(): Promise<void> {
        const currentUser = this.authService.getCurrentUser();
        let partner;
        if (!currentUser) {
            this.toastService.showInfo('Usuário não autenticado');
            return;
        }
        if (currentUser.partner?.id) {
            try {
                partner = await lastValueFrom(this.partnerService.getPartnerById(currentUser.partner.id));
                console.log("Parceiro Carregado", partner);
            } catch (error) {
                console.log("Erro ao buscar o parceiro", error)
            }
        }


        if (this.signatures.data.some(s => s.email?.toLowerCase() === currentUser.email?.toLowerCase())) {
            return;
        }

        const documento = extractDocumentFromEntity(partner);
        const documentoFormatado = formatDocument(documento);
        const telefone = partner?.cellPhone || '';

        const userSignature: IContractSignature = {
            code: this.generateSignatureCode(),
            name: partner?.name,
            email: partner?.email || '',
            document: documentoFormatado,
            whatsAppNumber: telefone,
            type: ContractSignatureType.CONTRATANTE,
            status: 'PENDENTE',
            isContracted: false,
            isDefaultContracted: false
        };

        if (partner) {
            this.variablesForm.patchValue({
                contractorName: partner.name,
                contractorDocument: documento,
                contractorEmail: partner.email,
                contractorTelephone: partner.cellPhone,
                contractorAddress: partner.address,
                contractorCity: partner.city,
                contractorState: partner.state,
            })
        }

        if (!userSignature.email || !documento) {
            this.toastService.showInfo('Não foi possível adicionar o usuário atual como signatário. Verifique seus dados cadastrais.');
            return;
        }

        this.signatures.data = [userSignature];
    }

    /**
     * Abre o diálogo para adicionar um novo assinante
     */
    addSignature(): void {
        const dialogRef = this.dialog.open(AddSignatureDialogComponent, {
            width: '500px',
            data: {
                allowedTypes: Object.values(ContractSignatureType).filter(
                    t => typeof t === 'number'
                )
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (this.signatures.data.some(s => s.email?.toLowerCase() === result.email?.toLowerCase())) {
                    this.toastService.showWarn(`O email ${result.email} já foi adicionado.`);
                    return;
                }

                const documento = result.document || '';
                const documentoFormatado = formatDocument(documento);

                const newSignature: IContractSignature = {
                    code: this.generateSignatureCode(),
                    name: result.name,
                    email: result.email,
                    document: documentoFormatado,
                    type: result.type as ContractSignatureType,
                    whatsAppNumber: result.whatsAppNumber || '',
                    status: 'PENDENTE',
                    isContracted: false,
                    isDefaultContracted: false
                };

                this.signatures.data = [...this.signatures.data, newSignature];
            }
        });
    }

    /**
     * Edita um assinante existente
     */
    editSignature(signature: IContractSignature, index: number): void {
        const dialogRef = this.dialog.open(AddSignatureDialogComponent, {
            width: '500px',
            data: {
                allowedTypes: Object.values(ContractSignatureType).filter(
                    t => typeof t === 'number'
                ),
                signature: { ...signature }
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (this.signatures.data.some((s, idx) => idx !== index && s.email?.toLowerCase() === result.email?.toLowerCase())) {
                    this.toastService.showWarn(`O email ${result.email} já pertence a outro signatário.`);
                    return;
                }

                const documento = result.document || signature.document || '';
                const documentoFormatado = formatDocument(documento);

                const updatedSignatures = [...this.signatures.data];
                updatedSignatures[index] = {
                    ...signature,
                    name: result.name,
                    email: result.email,
                    document: documentoFormatado,
                    type: result.type as ContractSignatureType,
                    whatsAppNumber: result.whatsAppNumber || signature.whatsAppNumber || '',
                };

                this.signatures.data = updatedSignatures;
            }
        });
    }

    /**
     * Remove um assinante
     */
    removeSignature(index: number): void {
        const signatureToRemove = this.signatures.data[index];

        // Não permite remover o usuário atual se for o único
        if (this.signatures.data.length === 1) {
            this.toastService.showWarn('É necessário ter pelo menos um signatário');
            return;
        }

        const updatedSignatures = [...this.signatures.data];
        updatedSignatures.splice(index, 1);
        this.signatures.data = updatedSignatures;
        this.toastService.showSuccess('Assinatura removida.');
    }

    /**
     * Gera um código único para a assinatura
     */
    private generateSignatureCode(index?: number): string {
        const timestamp = Date.now().toString(36);
        const randomPart = Math.random().toString(36).substring(2, 7);
        return `SIG_${index !== undefined ? index : ''}_${timestamp}_${randomPart}`.toUpperCase();
    }

    /**
     * Retorna o label do tipo de assinatura
     */
    getSignatureTypeLabel(type: ContractSignatureType | undefined | string): string {
        if (type === undefined || type === null) return 'Indefinido';

        if (typeof type === 'string') {
            const enumValues = Object.values(ContractSignatureType);
            if (enumValues.includes(type as any)) {
                return type;
            }

            const enumKey = type.toUpperCase() as keyof typeof ContractSignatureType;
            if (ContractSignatureType[enumKey]) {
                const enumValue = ContractSignatureType[enumKey];
                return typeof enumValue === 'string' ? enumValue : enumKey.charAt(0) + enumKey.slice(1).toLowerCase();
            }
        }

        return typeof type === 'string' ? type : 'Desconhecido';
    }

    /**
     * Formata uma data para exibição
     */
    formatDate(date: Date | undefined): string {
        if (!date) return 'Não informado';
        return this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss') || 'Formato inválido';
    }

    /**
     * Gera o contrato avulso
     */
    async generateContract(): Promise<void> {
        if (!this.contractForm.valid) {
            this.toastService.showError('Preencha todos os campos obrigatórios');
            return;
        }

        if (!this.templateFile && !this.variablesForm.value.templatesActives?.id) {
            this.toastService.showError('Selecione um arquivo de template');
            return;
        }

        if (this.signatures.data.length === 0) {
            this.toastService.showError('Adicione pelo menos um signatário.');
            return;
        }


        this.loading = true;

        try {
            const finalSignatures = this.signatures.data.map((sig, index) => ({
                ...sig,
                code: sig.code || this.generateSignatureCode(index + 1)
            }));

            const formData = new FormData();
            const formValue = this.variablesForm.value;
            formData.append('title', this.contractForm.value.title);
            formData.append('type', this.contractForm.value.type || '');
            formData.append('templateFile', this.templateFile || '');
            formData.append('signatures', JSON.stringify(finalSignatures));
            formData.append('entityType', 'standalone');
            formData.append('useZapSign', 'true');
            if (formValue.templatesActives?.id != null) {
                formData.append('templateId', formValue.templatesActives.id);
            }

            const isManual = (this.contractForm.value.type === 'manual');

            if (!isManual) {
                if (this.selectedEntity) {
                    formData.append('entityId', this.selectedEntity.id);
                    formData.append('entityDataType', this.entityType!);

                    if (this.entityType === 'customer' && this.selectedPlan) {
                        formData.append('planId', this.selectedPlan.id);
                    } else if (this.entityType === 'partner' && this.selectedPartnerRole) {
                        formData.append('contractType', this.selectedPartnerRole.type);
                    }
                }
                if (this.planId?.planId && this.planId?.systemId) {
                    formData.append('planId', this.planId.planId);
                    formData.append('systemId', this.planId.systemId);
                }

                const subscriberData = {
                    subscriberName: formValue.subscriberName,
                    subscriberDocument: formValue.subscriberDocument,
                    subscriberDocumentType: formValue.subscriberDocumentType,
                    subscriberEmail: formValue.subscriberEmail,
                    subscriberTelephone: formValue.subscriberTelephone,
                    subscriberPhone: formValue.subscriberPhone,
                    subscriberAddressNumber: formValue.subscriberAddressNumber,
                    subscriberCity: formValue.subscriberCity,
                    subscriberState: formValue.subscriberState,
                    subscriberCep: formValue.subscriberCep,
                };


                const contractorData = {
                    contractorName: formValue.contractorName,
                    contractorDocument: formValue.contractorDocument,
                    contractorEmail: formValue.contractorEmail,
                    contractorTelephone: formValue.contractorTelephone,
                    contractorAddress: formValue.contractorAddress,
                    contractorCity: formValue.contractorCity,
                    contractorState: formValue.contractorState,
                    contractorNameContract: formValue.contractorNameContract,
                    contractorDocumentContract: formValue.contractorDocumentContract,
                };


                formData.append('subscriber', JSON.stringify(subscriberData));
                formData.append('contractor', JSON.stringify(contractorData));

                formData.append('dueDate', formValue.dueDate);
                formData.append('firstDueDate', formValue.firstDueDate);

            }
            // this.openPreviewWithOriginalTemplate(this.formData(finalSignatures));
            const result = await this.contractGenerationService.generateStandaloneContract(formData).toPromise();
            //this.toastService.showInfo("EM PROGRESSO DE IMPLEMENTAÇÃO");

            if (result && result.id) {
                this.toastService.showSuccess('Contrato avulso gerado e enviado para assinaturas!');
                this.dialogRef.close(result);
            } else {
                throw new Error('Resposta inesperada da API');
            }
        } catch (error: any) {
            const errorMsg = error?.error?.message || error?.message || 'Erro desconhecido';
            this.toastService.showError(`Erro ao gerar contrato: ${errorMsg}`);
            console.error('Erro no generateContract:', error);
        } finally {
            this.loading = false;
        }
    }

    /**
     * Copia a variável para a área de transferência
     */
    copyVariable(variableName: string): void {
        navigator.clipboard.writeText(variableName).then(() => {
            this.toastService.showSuccess(`Variável ${variableName} copiada!`);
        }).catch(err => {
            console.error('Erro ao copiar:', err);
        });
    }

    /**
     * Fecha o diálogo
     */
    close(): void {
        this.dialogRef.close();
    }

    public getFieldConfig(name: string): any {
        return this.config.find((c) => c.name === name);
    }

    public openModalPlans() {
        let data: { selectedPartnerIds?: string[] } = {};
        if (this.entityType === 'partner') {
            data.selectedPartnerIds = [this.selectedEntity.id];
        }
        const dialogRef = this.dialog.open(PlanSelectionWizardComponent, {
            width: '80%',
            maxWidth: '95vw',
            maxHeight: '95vh',
            disableClose: false,
            data
        });

        dialogRef.afterClosed().subscribe(async (plans) => {
            this.plansStandalone[0] = plans.plan;
            this.planId = {
                planId: plans.plan.id,
                systemId: plans.plan.systemId
            }
        });

    }

    fillFormWithMockCPF(): void {
        this.variablesForm.patchValue(this.mockDataCPF);
    }

    /**
     * Preenche o formulário com dados de mock (Assinante Pessoa Jurídica).
     */
    fillFormWithMockCNPJ(): void {
        this.variablesForm.patchValue(this.mockDataCNPJ);
    }

    /**
     * Limpa os valores do formulário.
     */
    clearForm(): void {
        this.variablesForm.reset();
    }

    private openPreviewWithOriginalTemplate(contractData: any) {
        const dialogRef = this.dialog.open(ContractPreviewDialogComponent, {
            width: '90vw',
            height: '90vh',
            maxWidth: '95vw',
            maxHeight: '95vh',
            data: {
                contractData,
            },
            disableClose: false
        });

        const sub = dialogRef.componentInstance?.confirmGeneration.subscribe((genData: any) => {
            //this.proceedWithGeneration(genData, dialogRef);
        });

        dialogRef.afterClosed().subscribe(() => {
            sub?.unsubscribe();
            this.loading = false;
        });
    }
    private formData(finalSignatures: any): any {
        const payload: any = {
            title: this.contractForm.value.title,
            type: this.contractForm.value.type || '',
            signatures: finalSignatures,
            entityType: 'standalone',
            useZapSign: true,
        };

        const isManual = (this.contractForm.value.type === 'manual');

        if (!isManual) {
            const formValue = this.variablesForm.value;

            const subscriberData = {
                subscriberName: formValue.subscriberName,
                subscriberDocument: formValue.subscriberDocument,
                subscriberDocumentType: formValue.subscriberDocumentType,
                subscriberEmail: formValue.subscriberEmail,
                subscriberTelephone: formValue.subscriberTelephone,
                subscriberPhone: formValue.subscriberPhone,
                subscriberAddressNumber: formValue.subscriberAddressNumber,
                subscriberCity: formValue.subscriberCity,
                subscriberState: formValue.subscriberState,
                subscriberCep: formValue.subscriberCep,
            };

            const contractorData = {
                contractorName: formValue.contractorName,
                contractorDocument: formValue.contractorDocument,
                contractorEmail: formValue.contractorEmail,
                contractorTelephone: formValue.contractorTelephone,
                contractorAddress: formValue.contractorAddress,
                contractorCity: formValue.contractorCity,
                contractorState: formValue.contractorState,
                contractorNameContract: formValue.contractorNameContract,
                contractorDocumentContract: formValue.contractorDocumentContract,
            };

            payload.subscriber = subscriberData;
            payload.contractor = contractorData;
            payload.dueDate = formValue.dueDate;
            payload.firstDueDate = formValue.firstDueDate;
            payload.planId = this.planId?.planId || null;

            if (this.selectedEntity) {
                payload.entityId = this.selectedEntity.id;
                payload.entityDataType = this.entityType!;

                if (this.entityType === 'customer' && this.selectedPlan) {
                    payload.planId = this.selectedPlan.id;
                } else if (this.entityType === 'partner' && this.selectedPartnerRole) {
                    payload.contractType = this.selectedPartnerRole.type;
                }
            }

        }
        return payload;
    }

    private loadAllTemplates() {
        this.contractGenerationService.getTemplateStandalone().subscribe({
            next: (response: any) => {
                this.allTemplates = response;
                this.getFieldConfig('templatesActives').options = this.allTemplates.filter((r: any) => r.type === 'standalone');
            },
            error: (error: any) => {
                console.error("Erro ao Buscar Templates Ativos:", error);
            }
        });
    }

    protected selectContractActive() {
        this.clearTemplateFile()
    }
}
